<!-- キーワードから探す 大カテゴリラベル -->
<template>
  <div
    class="crly-a-common-search-category-large-label crly-icon"
    :class="category.catExlCd"
    @click="clickLrgCat"
  >
    <span>
      {{ category.catLrgNm }}
    </span>
  </div>
</template>

<script>
export default {
  name: "CrlyAtomsCommonSearchCategoryLargeLabel",
  props: {
    /**
     * 表示する小カテゴリ
     */
    category: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      routerPath: {
        // レジャー
        leisure: "CrlyLeisure",
        // グルメ
        gourmet: "CrlyGourmet",
        // 育児
        care: "CrlyChildcare",
        // 買い物
        shopping: "CrlyShopping",
        // リラク
        relaxation: "CrlyRelaxation",
        // スポーツ
        sports: "CrlySports",
        // 旅行
        travel: "CrlyTravel",
        // カー
        car: "CrlyCar",
        // オリジナル企画
        original: "CrlyOriginal",
        // 学ぶ
        skill: "CrlySchool",
        // ライフ
        life: "CrlyLife"
      }
    };
  },
  computed: {
    linkName() {
      return this.routerPath[this.category.catExlCd];
    }
  },
  methods: {
    clickLrgCat() {
      this.$emit("clickLrgCat");
      if (this.linkName !== this.$route.name) {
        // 表示中の画面と遷移先の画面が同じだとエラーになるので、異なる場合のみ遷移する
        this.$router.push({ name: this.linkName });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@crly/assets/css/atoms/common/search/category/largeLabel.scss";
</style>
